import React from 'react';

import { Loader2Icon } from 'lucide-react';

export const Loading = () => (
  <div className="h-screen w-screen flex items-center justify-center gap-2 max-w-full">
    <Loader2Icon className="animate-spin" />
    Loading ...
  </div>
);
